import React from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import useChangeCheck from "./useChangeCheck";
import ChangeCheckContext from "../support/ChangeCheckContext";

function BooleanInput(props) {

    const {disable} = React.useContext(ChangeCheckContext)
    const { onChange, getStyle } = useChangeCheck(props.onChange);

    function handleChange(event) {
        const checked = event.target.checked
        onChange({target: {name: props.name, value: checked}})
    }
    return (
        <>
            {props.label ? <Form.Label htmlFor="basic-url">{props.label}</Form.Label> : null}
            <InputGroup className="mb-3">
                <Form.Check disabled={disable} type="checkbox" name={props.name} onChange={handleChange} checked={props.value} style={getStyle()}/>
            </InputGroup>

        </>
    )
}

export default BooleanInput
